import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation.js';
import { localizePath } from '../utils/localizedRoutes.js';

// The two parts of the IDD page as links, shown at the top of each part, so a
// visitor sees both areas and can move between them. `current` marks the part
// the links stand in.
const parts = [
  { anchor: 'legacy', label: 'iddLegacy' },
  { anchor: 'method', label: 'iddMethod' }
];

const PageParts = ({ current }) => {
  const { t, currentLang } = useTranslation('agenticdev');

  return (
    <nav className="page-parts" aria-label={t.nav?.agenticdev}>
      {parts.map((part) => (
        <Link
          key={part.anchor}
          className={`page-parts__link${part.anchor === current ? ' page-parts__link--current' : ''}`}
          aria-current={part.anchor === current ? 'location' : undefined}
          to={`${localizePath('/agenticdev', currentLang)}#${part.anchor}`}
        >
          {t.nav?.[part.label]}
        </Link>
      ))}
    </nav>
  );
};

export default PageParts;
